import React, { useRef, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import '../css/Formulario.css';

const CampoForm = (props) => {
  const inputRef = useRef(null);  // Crear una referencia para el input
  const maxLength = props.maxLength || 10;
  
  useEffect(() => {
      inputRef.current.focus();  // Enfocar el input si autoFocus es true
  }, [props.pasos]);  // Se ejecuta cuando cambia autoFocus

  const textoAyuda = props.maxLength? `${props.value.length}/${maxLength} ${props.errorMessage ? ` - ${props.errorMessage}` : ''}` : props.errorMessage;

  return (
    <TextField
        inputRef={inputRef}  // Asignar la referencia al campo de entrada
        label={props.label}
        variant="standard"
        value={props.value}
        onChange={props.funcionalidad}
        helperText={textoAyuda}
        error={Boolean(props.errorMessage)}
        fullWidth
        color='success'
        type={props.type ? "number" : "text"}
        onKeyDown={props.enterKey}
        multiline={props.multiline}
        maxRows={4}
    />
  );
};

export default CampoForm;
